import { IconButton, styled } from '@mui/material';

export const StyledIconButton = styled(IconButton)({
  padding: '0',
  minHeight: '25px',
  minWidth: '25px',
  height: 'fit-content',
  width: 'fit-content',
});
